// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emailSend[data-v-1e53eee3] {\n  position: relative;\n  text-align: center;\n  font-size: 30px;\n  border-radius: 5px;\n  background-color: limegreen;\n  color: darkgreen;\n  padding: 0px;\n}\n.errorEmail[data-v-1e53eee3] {\n  position: relative;\n  text-align: center;\n  font-size: 30px;\n  border-radius: 5px;\n  background-color: #ce0000;\n  color: darkred;\n  padding: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
